import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "37",
  height: "48",
  fill: "none",
  viewBox: "0 0 37 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#576795",
      d: "M32.798 20.111 19.16.346A.8.8 0 0 0 17.847.34L4.001 20.111C-4.306 31.805 4.055 48 18.399 48s22.705-16.195 14.399-27.889"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#3B4E85",
      d: "m6.898 20.111 13.047-18.63L19.16.346A.8.8 0 0 0 17.847.34L4.001 20.111C-4.306 31.805 4.055 48 18.399 48q.735-.001 1.449-.056C6.4 46.898-1.124 31.406 6.898 20.11"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#9AA4C0",
      d: "M24.932 40.89a1.31 1.31 0 0 1 .194-1.84c2.815-2.278 4.442-5.787 4.354-9.39a1.31 1.31 0 0 1 1.275-1.34h.033c.708 0 1.29.564 1.308 1.276.11 4.408-1.881 8.703-5.323 11.488a1.31 1.31 0 0 1-1.841-.194"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#3B4E85",
      d: "M26.67 40.89a1.31 1.31 0 0 1 .195-1.84c2.815-2.278 4.442-5.787 4.353-9.39-.01-.4.161-.762.438-1.009a1.3 1.3 0 0 0-.868-.332h-.033a1.31 1.31 0 0 0-1.275 1.341c.088 3.602-1.539 7.112-4.354 9.39a1.309 1.309 0 1 0 1.646 2.034l.048-.04a1.3 1.3 0 0 1-.15-.154"
    }, null, -1)
  ])))
}
export default { render: render }